import {sortEntities} from '../ContactDB/normalizeContactList';

const getFullName = ({name, lastName}) => `${name} ${lastName}`;

const sortContacts = (a, b) =>
	getFullName(a)
		.toLowerCase()
		.localeCompare(getFullName(b).toLowerCase());

const mapContacts = ({
	userId,
	firstName: name,
	lastName,
	emailAddress,
	isInternal,
	roleId,
	roleName,
	serviceLineId,
	serviceLineName,
	engagementId: engagements
}) => ({
	userId,
	name,
	lastName,
	emailAddress,
	isInternal,
	roleId,
	roleName,
	serviceLineId,
	serviceLineName,
	engagements
});

const mapEntities = ({entityId, entityName, contacts}) => ({
	entityId,
	entityName,
	contacts: [...contacts].map(mapContacts).sort(sortContacts)
});

export default (data, orgChart) => sortEntities([...data].map(mapEntities), orgChart);
